import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "MODULES/Notifications/actions";
import renderIf from "MODULES/shared/decorators/renderIf";
import ConfirmModal from "./ConfirmModal";

function MarkAllRead({ markAllRead, ...props }) {
  const { filters } = props;
  const [confirmOpen, setConfirmOpen] = useState(false);
  const onClick = e => {
    e.stopPropagation();
    markAllRead(filters);
    setConfirmOpen(false);
  };

  return (
    <span className="input-group-btn">
      <button className="btn btn-danger" onClick={() => setConfirmOpen(true)}>
        Delete All
      </button>
      <ConfirmModal
        open={confirmOpen}
        close={() => setConfirmOpen(false)}
        onConfirm={onClick}
        prompt={[
          `Warning: This will delete your notifications. Are you sure you want to continue?`,
          <br />,
          <br />,
          "(Note: If results are filtered, only filtered notifications will be deleted.)"
        ]}
      />
    </span>
  );
}

MarkAllRead.propTypes = {
  filters: PropTypes.instanceOf(Object).isRequired,
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired
    }).isRequired
  ).isRequired,
  markAllRead: PropTypes.func.isRequired
};

export default renderIf(({ results }) => results && results.length)(
  connect(undefined, { markAllRead: actions.markAllRead })(MarkAllRead)
);



// WEBPACK FOOTER //
// ./app/modules/Notifications/components/Search/MarkAllRead/MarkAllRead.jsx